export enum ACCORDION_EVENT {
	EXPAND = "AccordionEvent.Expand",
	COLLAPSE = "AccordionEvent.Collapse",
	COLLAPSE_ALL = "AccordionEvent.CollapseAll",
}
